<script setup>
import {inject, onBeforeMount, reactive} from 'vue'
import {clone, getRoutes} from '@/paks/vu-app'
import {compressJson5} from '@/paks/js-polyfill'
import Json5 from 'json5'
import {Rules} from '@/paks/vu-rules'

const {modelValue: view} = defineProps({modelValue: Object})

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    components: null,
    properties: null,
    rules: Rules,
})

const form = inject('form', null)
const validate = inject('validate', null)

//  Home is deprecated
const ReservedComponents = ['VuManager', 'VuSign', 'Home']

onBeforeMount(() => {
    let components = Object.keys(getRoutes().getComponents()).sort()
    page.components = components.filter((c) => !ReservedComponents.includes(c))

    let properties = view.properties || {} 
    if (typeof properties === 'string') {
        properties = view.properties.replace(/^"(.+)"$/, '$1') || '{}'
    } else {
        properties = Json5.stringify(properties, null, 4)
    }
    page.properties = compressJson5(properties)
})

async function setProperties(properties) {
    let newView = clone(view)
    try {
        newView.properties = Json5.parse(properties)
        emit('update:modelValue', newView)
    } catch (e) {
        let v = validate.value
        if (v && form.value) {
            v.clear()
            await v.fieldError(form.value, 'properties', 'Syntax error in component properties')
        }
    }
}
</script>

<template>
    <vu-input
        type="select"
        v-model="view.component"
        label="Component"
        :items="page.components"/>
    <vu-input
        v-if="view.component"
        name="properties"
        label="Properties"
        v-model="page.properties"
        rows="20"
        :rules="page.rules.json5"
        placeholder="JSON Component Properties"
        type="textarea"
        @update:modelValue="setProperties" />
</template>

<style lang="scss">
.page-component-edit {
    .pick-view {
        margin: 16px 0 0px 0;
        width: 100%;
        .v-input__control {
            border-color: black;
            border-radius: 4px;
        }
    }
    .v-select-list {
        padding: 0;
        border: solid 1px rgb(var(--v-theme-border-lighten-1));
        border-radius: 0;
    }
    h3 {
        font-weight: normal;
        color: rgb(var(--v-theme-text));
    }
    .layouts {
        margin: 10px 0 20px 0;
    }
    .actions {
        margin: 20px 0 20px 0;
    }
    .v-list-item {
        min-height: 30px !important;
    }
    .v-list-item__content {
        padding: 6px 0 6px 0 !important;
    }
    .v-list {
        padding: 0;
    }
    .v-select__content {
        .v-list {
            background: rgb(var(--v-theme-background-lighten-1)) !important;
        }
    }
    margin-inline-start: 0 !important;
}
</style>

<style lang="scss" scoped>
.pick-items {
    font-size: 1rem;
}
.v-list-item {
    min-height: 30px !important;
}
.v-list-item__content {
    padding: 6px 0 6px 0 !important;
}
.v-list {
    padding: 0;
}
</style>
